let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ltbtG")).then(() => parcelRequire('cc10A'));